import { goSolidApi } from "@/composables/useGoSolidApi";
import type { DealEurConversion } from "@/types";

export interface MarketPriceData {
  date: string;
  bid: string | null;
}

/** A completed sale against the EUR market bid: `unit_price` and `delta_vs_market` are EUR/MWh. */
export interface TransactionPerformanceData extends DealEurConversion {
  id: number;
  transaction_at: string;
  unit_price: string;
  amount: number;
  counterparty_name: string | null;
  description: string | null;
  reference_market_price: string | null;
  delta_vs_market: string | null;
  is_forward: boolean;
}

export interface PerformanceMetrics {
  total_transactions: number;
  transactions_with_market_price: number;
  average_unit_price: string | null;
  average_market_price: string | null;
  average_premium: string | null;
  weighted_average_premium: string | null;
  weighted_average_market_price: string | null;
}

export interface PerformanceResponse {
  market_prices: MarketPriceData[];
  transactions: TransactionPerformanceData[];
}

export async function fetchTransactionPerformance(
  vintage: number,
  dateFrom?: string,
  dateTo?: string
): Promise<PerformanceResponse> {
  const params = new URLSearchParams();
  params.append("vintage", vintage.toString());
  if (dateFrom) {
    params.append("date_from", dateFrom);
  }
  if (dateTo) {
    params.append("date_to", dateTo);
  }

  const response = await goSolidApi.get<PerformanceResponse>(
    `/api/admin/transactions/performance?${params.toString()}`
  );
  return response.data;
}
